import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { faPencil } from '@fortawesome/pro-solid-svg-icons';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import type { Props as ButtonProps } from '@sorare/core/src/atoms/buttons/Button';
import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';

import { UpsertWatchlistDialog } from '#src/components/watchlists/UpsertWatchlistDialog/index.tsx';

import type { EditWatchlistButton_watchlist } from './__generated__/index.graphql.ts';

type Props = ButtonProps & {
  onSuccess?: () => void;
  watchlist: EditWatchlistButton_watchlist;
};

export const EditWatchlistButton = ({
  onSuccess,
  watchlist,
  ...props
}: Props) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        startIcon={<FontAwesomeIcon icon={faPencil} size="sm" />}
        {...props}
        onClick={() => setOpen(true)}
      >
        <FormattedMessage
          id="watchlist.EditWatchlistButton.editWatchlist"
          defaultMessage="Edit"
        />
      </Button>
      <UpsertWatchlistDialog
        open={open}
        onClose={() => setOpen(false)}
        onSuccess={onSuccess}
        watchlist={watchlist}
      />
    </>
  );
};
EditWatchlistButton.fragments = {
  watchlist: gql`
    fragment EditWatchlistButton_watchlist on Watchlist {
      slug
      ...UpsertWatchlistDialog_watchlist
    }
    ${UpsertWatchlistDialog.fragments.watchlist}
  ` as TypedDocumentNode<EditWatchlistButton_watchlist>,
};
